import { Dispatch, SetStateAction } from 'react';

export type LastPosition = { x: number; y: number } | null;

const calculateZoomedViewBox = (
  viewBox: string,
  zoomFactor: number
): string => {
  const [minX, minY, width, height] = viewBox.split(' ').map(Number);
  return `${minX} ${minY} ${width * zoomFactor} ${height * zoomFactor}`;
};

export const zoomIn = (
  viewBox: string,
  setViewBox: Dispatch<SetStateAction<string>>
) => {
  const zoomFactor = 1.1;
  const newViewBox = calculateZoomedViewBox(viewBox, zoomFactor);
  setViewBox(newViewBox);
};

export const zoomOut = (
  viewBox: string,
  setViewBox: Dispatch<SetStateAction<string>>
) => {
  const zoomFactor = 0.9;
  const newViewBox = calculateZoomedViewBox(viewBox, zoomFactor);
  setViewBox(newViewBox);
};

export const drag = (
  x: number,
  y: number,
  viewBox: string,
  lastPosition: LastPosition,
  setViewBox: Dispatch<SetStateAction<string>>,
  isDragging: boolean,
  setLastPosition: Dispatch<SetStateAction<LastPosition>>
) => {
  if (!isDragging || !lastPosition) return;

  const deltaX = x - lastPosition.x;
  const deltaY = y - lastPosition.y;

  const [minX, minY, width, height] = viewBox.split(' ').map(Number);
  const newViewBox = `${minX - deltaX} ${minY - deltaY} ${width} ${height}`;
  setViewBox(newViewBox);

  setLastPosition({ x, y });
};
